/**
 * Solo sauna PDP: per-variant prices on block swatches + price row updates.
 */
(function () {
    function formatMoney(cents) {
      const format =
        window.theme?.moneyFormat ||
        (typeof Shopify !== 'undefined' && Shopify.money_format) ||
        '${{amount}}';
  
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, format);
      }
  
      return '$' + (cents / 100).toFixed(2);
    }
  
    function initSoloGallery(section) {
      const gallery = section.querySelector('.product-gallery--solo-sauna');
      if (!gallery) return;

      const carousel = gallery.querySelector('media-carousel');
      const pagination = gallery.querySelector('[data-solo-sauna-gallery-pagination]');
      if (!carousel || !pagination) return;

      const dots = Array.from(pagination.querySelectorAll('.solo-sauna-gallery-pagination__dot'));
      if (dots.length < 2) {
        pagination.hidden = true;
        return;
      }

      pagination.hidden = false;

      function syncDots(selectedIndex) {
        dots.forEach((dot) => {
          const index = parseInt(dot.getAttribute('data-carousel-index'), 10);
          dot.setAttribute('aria-current', index === selectedIndex ? 'true' : 'false');
        });
      }

      function applyFilter(filteredIndexes) {
        let visible = 0;
        dots.forEach((dot) => {
          const index = parseInt(dot.getAttribute('data-carousel-index'), 10);
          const hidden = Array.isArray(filteredIndexes) && filteredIndexes.includes(index);
          dot.hidden = hidden;
          if (!hidden) visible += 1;
        });
        pagination.hidden = visible < 2;
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.getAttribute('data-carousel-index'), 10);
          if (!Number.isNaN(index)) {
            carousel.select(index, { animate: true });
          }
        });
      });

      carousel.addEventListener('carousel:change', (event) => {
        syncDots(event.detail.index);
      });

      carousel.addEventListener('carousel:filter', (event) => {
        applyFilter(event.detail.filteredIndexes);
      });

      syncDots(carousel.selectedIndex);
    }

    function updateSoloSaunaPrice(section, variant) {
      const priceHost = section.querySelector('[data-solo-sauna-price]');
      if (!priceHost || !variant) return;

      const saleEl = priceHost.querySelector('sale-price');
      const compareEl = priceHost.querySelector('compare-at-price');
      const onSale = variant.compare_at_price > variant.price;

      if (saleEl) {
        const lastChild = saleEl.lastChild;
        if (lastChild) {
          lastChild.replaceWith(
            document.createRange().createContextualFragment(formatMoney(variant.price))
          );
        }
        saleEl.classList.toggle('text-on-sale', onSale);
        saleEl.classList.toggle('bold', onSale);
      } else {
        const fallback = priceHost.querySelector('.text-on-sale, .text-lg, .price-list');
        if (fallback) {
          fallback.textContent = formatMoney(variant.price);
        }
      }

      if (compareEl) {
        const lastChild = compareEl.lastChild;
        if (lastChild) {
          lastChild.replaceWith(
            document.createRange().createContextualFragment(formatMoney(variant.compare_at_price))
          );
        }
        compareEl.hidden = !onSale;
      }
    }

    function initSoloPriceUpdate(section) {
      const priceHost = section.querySelector('[data-solo-sauna-price]');
      const form = section.querySelector('form[is="product-form"]');
      if (!priceHost || !form || form.dataset.soloSaunaPriceBound === 'true') return;

      form.dataset.soloSaunaPriceBound = 'true';
      form.addEventListener('variant:change', (event) => {
        const variant = event.detail?.variant;
        if (variant) updateSoloSaunaPrice(section, variant);
      });
    }

    function initSection(section) {
      initSoloGallery(section);

      const formId = section.querySelector('form[is="product-form"]')?.id;
      if (!formId) return;
  
      const form = document.getElementById(formId);
      const variantsScript = section.querySelector('[data-solo-sauna-variants]');
      if (!form || !variantsScript) return;
  
      let variants;
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        return;
      }
  
      function decorateVariantCards() {
        section.querySelectorAll('.solo-sauna-variant-picker .block-swatch').forEach((label) => {
          if (label.querySelector('[data-solo-sauna-variant-price]')) return;
  
          const input =
            label.previousElementSibling?.matches?.('input[type="radio"]') &&
            label.previousElementSibling.name?.startsWith('option')
              ? label.previousElementSibling
              : null;
  
          if (!input) return;
  
          const optionIndex = parseInt(input.name.replace('option', ''), 10) - 1;
          const match = variants.find((v) => v.options[optionIndex] === input.value);
          if (!match) return;
  
          const priceEl = document.createElement('span');
          priceEl.className = 'solo-sauna-variant-card__price';
          priceEl.setAttribute('data-solo-sauna-variant-price', '');
          priceEl.textContent = formatMoney(match.price);
          label.appendChild(priceEl);
        });
      }
  
      decorateVariantCards();
    }

    function initSoloPricing(section) {
      const form = section.querySelector('form[is="product-form"]');
      const shippingValuesScript = section.querySelector('[data-solo-sauna-free-shipping-values]');
      if (!form || !shippingValuesScript) return;

      let shippingRowByVariantId = {};
      const gateFreeShipping = Boolean(
        shippingValuesScript.closest('[data-gate-free-shipping]')
      );

      try {
        const shippingRows = JSON.parse(shippingValuesScript.textContent);
        shippingRowByVariantId = Object.fromEntries(
          shippingRows.map((row) => [String(row.id), row])
        );
      } catch (e) {
        return;
      }

      function updateShippingRow(variant) {
        const badgeEl = section.querySelector('[data-solo-sauna-shipping-badge]');
        const valueEl = section.querySelector('[data-solo-sauna-shipping-value]');
        if (!variant) return;

        const row = shippingRowByVariantId[String(variant.id)] || {};

        if (badgeEl && gateFreeShipping) {
          badgeEl.hidden = row.showBadge !== true;
        }

        if (!valueEl) return;

        const label = row.label || '';

        if (label) {
          valueEl.textContent = label;
          valueEl.hidden = false;
        } else {
          valueEl.textContent = '';
          valueEl.hidden = true;
        }
      }

      form.addEventListener('variant:change', (event) => {
        const variant = event.detail?.variant;
        if (variant) updateShippingRow(variant);
      });
    }
  
    function hideTrustpilotContainer(container) {
      container.hidden = true;

      const liquidWrapper = container.closest('[data-trustpilot-liquid], .product-info__liquid');
      if (liquidWrapper && !liquidWrapper.querySelector('[data-trustpilot-container]:not([hidden])')) {
        liquidWrapper.hidden = true;
      }
    }

    function revealTrustpilotContainer(container) {
      container.hidden = false;

      const liquidWrapper = container.closest('[data-trustpilot-liquid], .product-info__liquid');
      if (liquidWrapper) {
        liquidWrapper.hidden = false;
      }
    }

    function trustpilotWidgetHasReviews(widget) {
      if (widget.querySelector('a[href*="trustpilot.com"]')) {
        return false;
      }

      const iframe = widget.querySelector('iframe');
      if (iframe && iframe.getBoundingClientRect().height > 20) {
        return true;
      }

      return false;
    }

    function initTrustpilotContainers(root) {
      root.querySelectorAll('[data-trustpilot-container]').forEach((container) => {
        const widget = container.querySelector('.trustpilot-widget');
        if (!widget) {
          hideTrustpilotContainer(container);
          return;
        }

        const checkWidget = () => {
          if (trustpilotWidgetHasReviews(widget)) {
            revealTrustpilotContainer(container);
            return true;
          }

          hideTrustpilotContainer(container);
          return false;
        };

        [500, 1500, 3000, 5000, 8000].forEach((delay) => {
          window.setTimeout(checkWidget, delay);
        });
      });
    }

    function hideReviewSection(block) {
      block.hidden = true;

      const shopifySection = block.closest('.shopify-section');
      if (shopifySection) {
        shopifySection.hidden = true;
      }
    }

    function revealReviewSection(block) {
      block.hidden = false;

      const shopifySection = block.closest('.shopify-section');
      if (shopifySection) {
        shopifySection.hidden = false;
      }
    }

    function initReviewSections(root) {
      root.querySelectorAll('[data-reviews-section]').forEach((block) => {
        const widgets = block.querySelectorAll('.trustpilot-widget');
        if (!widgets.length) {
          block.hidden = false;
          return;
        }

        block.hidden = true;

        const checkSection = () => {
          const hasReviews = Array.from(widgets).some((widget) => trustpilotWidgetHasReviews(widget));

          if (hasReviews) {
            revealReviewSection(block);
          } else {
            hideReviewSection(block);
          }
        };

        checkSection();
        [500, 1500, 3000, 5000, 8000, 10000].forEach((delay) => {
          window.setTimeout(checkSection, delay);
        });
      });
    }

    function initSoloReviewsSection(section) {
      if (!section.classList.contains('shopify-section--solo-reviews')) return;

      const embed = section.querySelector('.solo-reviews__embed');
      if (!embed) {
        section.hidden = true;
        return;
      }

      const iframe = embed.querySelector('iframe');
      if (!iframe) {
        section.hidden = true;
        return;
      }

      const hideIfEmpty = () => {
        const height = Math.max(
          iframe.getBoundingClientRect().height,
          iframe.offsetHeight,
          embed.getBoundingClientRect().height
        );

        if (height < 48) {
          section.hidden = true;
        }
      };

      iframe.addEventListener('load', () => {
        window.setTimeout(hideIfEmpty, 800);
        window.setTimeout(hideIfEmpty, 2500);
      });

      window.setTimeout(hideIfEmpty, 3000);
      window.setTimeout(hideIfEmpty, 6000);
    }

    function init() {
      initTrustpilotContainers(document);
      initReviewSections(document);

      document.querySelectorAll('.shopify-section--main-product').forEach((section) => {
        initSoloGallery(section);
        initSoloPriceUpdate(section);
        if (!section.querySelector('.solo-sauna-pdp')) return;
        initSection(section);
        initSoloPricing(section);
      });

      document.querySelectorAll('.shopify-section--solo-reviews').forEach(initSoloReviewsSection);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  
    document.addEventListener('shopify:section:load', (event) => {
      initTrustpilotContainers(event.target);
      initReviewSections(event.target);

      if (event.target.classList.contains('shopify-section--main-product')) {
        initSoloGallery(event.target);
        initSoloPriceUpdate(event.target);
        if (event.target.querySelector('.solo-sauna-pdp')) {
          initSection(event.target);
          initSoloPricing(event.target);
        }
      }

      if (event.target.classList.contains('shopify-section--solo-reviews')) {
        initSoloReviewsSection(event.target);
      }
    });
  })();
  